import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppConfigService} from './app-config.service';
import {MaterialModule} from './material.module';
import {CertinomisComponent} from './Certinomis/certinomis.component';
import {HeaderComponent} from './components/header/header.component';
import {FinalizeOrderComponent} from './Certinomis/finalize.order.component';
import {ConfirmationDialogComponent} from './components/dialogs/confirmation-dialog.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import { PluralizeYearPipe } from './pluralize-year.pipe';
import {ProductDetailComponent} from './Certinomis/product.detail.component';
import {CgvComponent} from './Certinomis/cgv.component';
import {CertinomisGuard} from './certinomis.guard';



export function initializeApp(appConfig: AppConfigService): () => Promise<void> {
  return () => appConfig.loadConfig();
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    CertinomisComponent,
    FinalizeOrderComponent,
    ConfirmationDialogComponent,
    CgvComponent,
    ProductDetailComponent,
    PluralizeYearPipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    BrowserAnimationsModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  providers: [AppConfigService, {
    provide: APP_INITIALIZER,
    useFactory: initializeApp,
    deps: [AppConfigService],
    multi: true,
  },
    CertinomisGuard],
  bootstrap: [AppComponent]
})
export class AppModule {
}
